import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
export const FooterViewParent = styled.div `
    padding: 0 80px 24px 80px;
    background-color: ${colors.white_background};
    align-self: stretch;
`;
export const FooterDivider = styled.div `
    border-top: 1px solid ${colors.black_12};
    margin-bottom: 16px;
`;
export const FooterLinks = styled.div `
    display: flex;
    font-size: ${fontSizes.STANDARD};
    font-weight: 600;

    & :not(:first-child) {
        padding-left: 8px;
    }
    & :not(:last-child) {
        padding-right: 8px;
        border-right: 1px solid ${colors.black_12};
    }
`;
export const FooterCopyright = styled.div `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
`;
export const FooterPoweredByAndLinks = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
`;
export const FooterPoweredBy = styled.div ``;
export const FooterPoweredByText = styled.div `
    font-size: ${fontSizes.SMALL};
    margin-bottom: 4px;
`;
export const FooterCompanyLogo = styled.img `
    height: 32px;
    cursor: pointer;
`;
